import { buildKahuLinkPath, parseKahuHref } from '@/utils/kahu-link-helpers';

import { truncateTraceId } from '@/components/display-page/traces/traceUtils';

import { KahuResponseLink } from '../kahu-response-link';
import { PromptListLinkProps } from './prompt-list';

export const TraceIdLink = function ({
  block,
  occurrenceKey,
  copiedInfo,
  setCopiedInfo,
}: {
  // Only the id + deep-link href are needed, so this is shared by both the
  // prompt list and the trace list.
  block: { traceId: string; href: string };
  occurrenceKey: string;
} & Omit<PromptListLinkProps, 'messageId'>) {
  const tracePath = block.href
    ? buildKahuLinkPath(parseKahuHref(block.href))
    : null;

  if (!tracePath) {
    return (
      <code className="rounded bg-[#FFFFFF14] px-[3px] text-body font-normal text-body-primary">
        {truncateTraceId(block.traceId)}
      </code>
    );
  }

  // Stop card-level clicks (copy button / link) from also opening the modal.
  return (
    <span onClick={(event) => event.stopPropagation()}>
      <KahuResponseLink
        text={block.traceId}
        href={tracePath}
        occurrenceKey={occurrenceKey}
        copiedInfo={copiedInfo}
        setCopiedInfo={setCopiedInfo}
      />
    </span>
  );
};
